
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RespondToUserMessageMessage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AiCoach_MessageByAiCoach"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"senderType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"messageId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"structuredResponse"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RespondToUserMessageNavigationButtons"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AiCoach_NavigationButtonV2"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AiCoach_ItemNavigationButton"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemNavigationButton"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AiCoach_RedirectLinkNavigationButton"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedirectLinkNavigationButton"},"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AiCoachPlatform_RespondToUserMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiCoach_RespondToUserMessageInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AiCoach_RespondToUserMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSessionId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"messageByAiCoach"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RespondToUserMessageMessage"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"embeddedContents"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmbeddedContent"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"recommendedActions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CoachRecommendedAction"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"navigationButtons"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RespondToUserMessageNavigationButtons"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"recommendedEdits"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CoachRecommendedEdit"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"productCards"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CoachRecommendedProductCards"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1161}};
    doc.loc.source = {"body":"#import \"./navigationButtonFragment.graphql\"\n#import \"./coachRecommendedActionFragment.graphql\"\n#import \"./coachRecommendedEditFragment.graphql\"\n#import \"./coachRecommendedProductCardsFragment.graphql\"\n#import \"./embeddedContentFragment.graphql\"\n\nfragment RespondToUserMessageMessage on AiCoach_MessageByAiCoach {\n  message\n  senderType\n  messageId\n  structuredResponse\n}\n\nfragment RespondToUserMessageNavigationButtons on AiCoach_NavigationButtonV2 {\n  ... on AiCoach_ItemNavigationButton {\n    ...ItemNavigationButton\n  }\n  ... on AiCoach_RedirectLinkNavigationButton {\n    ...RedirectLinkNavigationButton\n  }\n}\n\nmutation AiCoachPlatform_RespondToUserMessage($input: AiCoach_RespondToUserMessageInput!) {\n  AiCoach_RespondToUserMessage(input: $input) {\n    chatSessionId\n    messageByAiCoach {\n      ...RespondToUserMessageMessage\n    }\n    embeddedContents {\n      ...EmbeddedContent\n    }\n    recommendedActions {\n      ...CoachRecommendedAction\n    }\n    navigationButtons {\n      ...RespondToUserMessageNavigationButtons\n    }\n    recommendedEdits {\n      ...CoachRecommendedEdit\n    }\n    productCards {\n      ...CoachRecommendedProductCards\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./navigationButtonFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./coachRecommendedActionFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./coachRecommendedEditFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./coachRecommendedProductCardsFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./embeddedContentFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["RespondToUserMessageMessage"] = oneQuery(doc, "RespondToUserMessageMessage");
        
        module.exports["RespondToUserMessageNavigationButtons"] = oneQuery(doc, "RespondToUserMessageNavigationButtons");
        
        module.exports["AiCoachPlatform_RespondToUserMessage"] = oneQuery(doc, "AiCoachPlatform_RespondToUserMessage");
        
